import $ from 'jquery';

(function (el) {
    if ($(el).length < 1) return false;

    $('[data-file-upload]').click(function (e) {
        e.preventDefault();

        var $this = $(this);
        var $parent = $this.parent();
        var $input = $parent.find('input[type="file"]');
        if ($input.length > 0) $input.trigger('click');
    });

    var tmpFiles = [];
    var $list = $('.files__list');
    var $warn = $('.files__description');
    //var $adding = $('#product-reviews-adding');
    //var $add = $('#product-reviews-add');
    //var $success = $('#product-reviews-success');

    function recount() {
        var $items = $('[data-file-id]');
        for (var i = 0; i < $items.length; i++) {
            $items.eq(i).attr('data-file-id', i);
        }
    }

    function makeWarn() {
        setTimeout(function () {
            $warn.css('color', '#ff0000');
            setTimeout(function () {
                $warn.removeAttr('style');
            }, 3000);
        }, 500);
    }

    $('input.files__input[type="file"]').change(function () {
        var files = this.files;

        for (var i = 0; i <= files.length - 1; i++) {
            if (tmpFiles.length >= 10) {
                makeWarn();
                break;
            }
            tmpFiles.push(files[i]);
            $list.append(
                '<div class="files__list-item" data-file-id="' + i + '">' +
                '<div class="files__list-item-close"></div>' +
                '<div class="files__list-item-text">' + files[i].name + '</div>' +
                '</div>'
            );
            recount();
        }

    });

    $(document).on('click', '.files__list-item-close', function () {
        var $this = $(this);
        var $item = $this.parent('[data-file-id]');
        var index = $item.attr('data-file-id');

        tmpFiles.splice(index, 1);
        $item.remove();
        recount();
    });

    /*
    $('.review-adding__form').submit(function() {
      var dataFiles = new FormData();
      var count = 0;

      $.each(tmpFiles, function(i, file){
        dataFiles.append(count, file);
        count++;
      });

      $adding.collapse('hide');
      $add.collapse('hide');
      setTimeout(function() {
        $success.collapse('show');
      }, 500);

      return false;
    });
    */
})('[data-file-upload]');
